import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Button,
  ButtonProps,
  Container,
  Divider,
  Drawer,
  IconButton,
  ImageListItem,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { ReactNode } from "react";
import LogoImage from "../../../assets/images/ZeaIQ-Logo.svg";
import MenuIcon from "@mui/icons-material/Menu";
import variables from "../../../assets/styles/variables.module.scss";
import { Outlet, useNavigate } from "react-router-dom";

interface MyComponentProps {
  children?: ReactNode; // Ensure you define children prop type
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryColor,
  "&:hover": {
    backgroundColor: variables.secondaryColor,
  },
}));

const MinimalLayout: React.FC<MyComponentProps> = ({}) => {
  // const  window } = children;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const drawerWidth = 240;
  const navigate = useNavigate();
  const navItems = [
    { name: "Home", path: "/login" },
    { name: "About", path: "/login" },
    { name: "Pricing", path: "/login" },
    { name: "Help", path: "/login" },
  ];
  const container =
    window !== undefined ? () => window.document.body : undefined;
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box sx={{ py: 2 }}>
        <img
          src={LogoImage}
          alt="Company Logo"
          style={{ width: 120, height: "auto" }}
        />
      </Box>
      <Divider />
      <List>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText
                primary={item.name}
                onClick={() => navigate(item.path)}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <>
      <Container
        maxWidth={false}
        sx={{ borderBottom: `1px solid ${variables.borderColor}` }}
      >
        <AppBar
          component="nav"
          position="static"
          elevation={0}
          sx={{ background: variables.whiteColor, px: { lg: 1 } }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 2,
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 1,
                display: { md: "none" },
                color: variables.blackColor,
              }}
            >
              <MenuIcon />
            </IconButton>
            <ImageListItem
              sx={{
                marginRight: { xs: "auto", sm: "auto", md: "unset" },
              }}
            >
              <img
                src={LogoImage}
                alt="Company Logo"
                style={{ width: 150, height: "auto" }}
              />
            </ImageListItem>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
              {navItems.map((item, index) => (
                <Button
                  key={index}
                  sx={{
                    color: variables.textColor,
                    textTransform: "capitalize",
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.name}
                </Button>
              ))}
            </Box>
            <Box
              display="flex"
              sx={{
                gap: "15px",
              }}
            >
              <Button
                variant="outlined"
                size={isSmallScreen ? "small" : "large"}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  color: variables.textColor,
                  borderColor: variables.textColor,
                  "&:hover": {
                    color: variables.secondaryColor,
                    borderColor: variables.secondaryColor,
                  },
                }}
                onClick={() => navigate("/login")}
              >
                Sign in
              </Button>
              <ColorButton
                variant="contained"
                disableElevation
                size={isSmallScreen ? "small" : "large"}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                }}
                onClick={() => navigate("/register")}
              >
                Get Started
              </ColorButton>
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </Container>
      {/* {children} */}

      <Box
        sx={{
          minHeight: "calc(100vh - 78px)",
        }}
      >
        <Outlet /> {/* This will render nested routes */}
      </Box>
    </>
  );
};
export default MinimalLayout;
